import { render } from "./passwordReset.vue?vue&type=template&id=66a47884"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__